import type { ReactNode } from 'react';

interface FieldProps {
  label: string;
  htmlFor: string;
  error?: string | undefined;
  hint?: string;
  children: ReactNode;
}

export function Field({ label, htmlFor, error, hint, children }: FieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={htmlFor} className="text-fg text-xs font-semibold">
        {label}
      </label>
      {children}
      {error ? (
        <p id={`${htmlFor}-description`} role="alert" className="text-danger text-xs">
          {error}
        </p>
      ) : hint ? (
        <p id={`${htmlFor}-description`} className="text-fg-subtle text-xs">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
